import PostUploadAttachments from './post-upload-attachments';

export default PostUploadAttachments;